import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useStore } from '@/store/useStore';
import { Mail, Lock, User, Loader } from 'lucide-react';

export const RegisterPage = () => {
  const navigate = useNavigate();
  const { webRegister, loading, error, clearError } = useStore();
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [localError, setLocalError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLocalError('');
    clearError();

    if (password !== confirm) {
      setLocalError('Пароли не совпадают');
      return;
    }
    if (password.length < 8) {
      setLocalError('Пароль должен содержать не менее 8 символов');
      return;
    }

    try {
      await webRegister(email, password, username || undefined);
      navigate('/', { replace: true });
    } catch {
      // error from store
    }
  };

  const displayError = localError || error;

  return (
    <div className="min-h-screen flex items-center justify-center bg-telegram-bg px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="text-5xl mb-3">🎰</div>
          <h1 className="text-2xl font-bold text-telegram-text">Ruffle</h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Платформа розыгрышей</p>
        </div>

        {/* Card */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700 p-6">
          <h2 className="text-lg font-semibold text-telegram-text mb-5">Регистрация</h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-telegram-text mb-1">Email</label>
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="you@example.com"
                  className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 text-telegram-text text-sm focus:outline-none focus:ring-2 focus:ring-telegram-button"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-telegram-text mb-1">
                Имя пользователя <span className="text-gray-400 font-normal">(необязательно)</span>
              </label>
              <div className="relative">
                <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="ivan123"
                  className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 text-telegram-text text-sm focus:outline-none focus:ring-2 focus:ring-telegram-button"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-telegram-text mb-1">Пароль</label>
              <div className="relative">
                <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Минимум 8 символов"
                  className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 text-telegram-text text-sm focus:outline-none focus:ring-2 focus:ring-telegram-button"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-telegram-text mb-1">Повторите пароль</label>
              <div className="relative">
                <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                  placeholder="••••••••"
                  className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 text-telegram-text text-sm focus:outline-none focus:ring-2 focus:ring-telegram-button"
                />
              </div>
            </div>

            {displayError && (
              <p className="text-sm text-red-500 dark:text-red-400">{displayError}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 bg-telegram-button text-telegram-buttonText font-semibold py-2.5 rounded-lg hover:opacity-90 transition-opacity disabled:opacity-60"
            >
              {loading ? <Loader size={16} className="animate-spin" /> : null}
              Зарегистрироваться
            </button>
          </form>
        </div>

        <p className="text-center text-sm text-gray-500 dark:text-gray-400 mt-4">
          Уже есть аккаунт?{' '}
          <Link to="/login" className="text-telegram-button font-medium hover:underline">
            Войти
          </Link>
        </p>
      </div>
    </div>
  );
};
